import { _PageService } from './_page.service';
import { TRouteCreate } from '../route-service/models/route-create';

export abstract class _LevelGlobalPageService
    extends _PageService
{
    constructor(
        pageCreate_name: TRouteCreate | null,
    ){
        super(
            pageCreate_name,
        )
    }
}
